<template>
  <div class="app-wrapper" :class="{hideSidebar:!sidebar.opened}">
    <layout-left></layout-left>
    <div class="main-container">
      <layout-header></layout-header>
      <layout-center></layout-center>
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>

import {LayoutLeft, LayoutHeader, LayoutFooter, LayoutCenter} from '~/views/layouts'
import Sidebar from '~/widgets/Sidebar.vue'

export default {
  name: 'Layout',
  components: {
    LayoutLeft,
    LayoutHeader,
    LayoutFooter,
    LayoutCenter,
    Sidebar
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/layouts/Layout.vue